import HNSColors from "../../../../../ui library/HNSColors";

export const STYLES = {
  textField: {
    "& .MuiOutlinedInput-root": {
      padding: "0",
      borderRadius: "8px",
      transition: "border-color 0.3s",
      "& fieldset": {
        borderColor: HNSColors.neutrals[400],
      },
      "&.Mui-focused fieldset": {
        border: `1.5px solid ${HNSColors.secondary[500]}`,
      },
      "& .MuiInputBase-input": {
        padding: "8px",
      },
      "& .MuiInputBase-input textarea": {
        padding: "1.5px",
      },
      "& .MuiSelect-icon": {
        color: HNSColors.primary[500],
      },
    },
  },
  
};
